// extracted by mini-css-extract-plugin
export var colorBase = "ZRMCUJ1FSZhg1iyDH5vY";
export var colorDisabled = "g_GwxGazjLOB2o2xZc9A";
export var colorInverted = "UerKU8uZOVwskAB5HAsu";
export var colorNegative = "Ew9CdC159fZQz5j1iV3K";
export var colorPositive = "F3nttTbkzYPDp431njjw";
export var colorSubdued = "xjs3ZNi5_BwI8_QXZDSR";
export var colorSubtle = "Ofc6kIrKG0bNPv6gvT0Y";
export var colorUrgencyHigh = "CccgDBepoWDHDoH2z7Sp";
export var colorUrgencyMedium = "P8p0uxH1nfihR6NsKPNN";
export var colorWarning = "swAH9D3qTeTiyvvcqtKU";
export var colorWhite = "XFWBABTpLQRYtf409_hy";